module.exports = __webpack_public_path__ + "img/tigerair-taiwan.7599113b.png";